import React from 'react';
import { Link } from 'react-router-dom';

const PolicyEmbed = ({ id, title }) => {
  const embedCode = `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          body { margin: 0; font-family: sans-serif; color: #333333; }
          a { color: #eab308; }
        </style>
      </head>
      <body>
        <div id="${id}" class="policy_embed_div" width="640" height="480">
          Please wait while the policy is loaded. If it does not load, please <a rel="nofollow" href="https://policies.termageddon.com/api/policy/${id}" target="_blank">click here</a> to view the policy.
        </div>
        <script src="https://policies.termageddon.com/api/embed/${id}.js"></script>
      </body>
    </html>
  `;

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] p-4 md:p-8">
      <div className="max-w-4xl mx-auto glass-card p-8 border-yellow-500/20">
        <Link to="/" className="text-yellow-500 hover:underline mb-4 block flex items-center gap-2">
           &larr; Back to Home
        </Link>
        <h1 className="text-3xl font-bold mb-6 text-[var(--text-primary)]">{title}</h1>
        <iframe
          title={title}
          srcDoc={embedCode}
          style={{ width: '100%', minHeight: '800px', border: 'none', backgroundColor: 'transparent' }}
        />
      </div>
    </div>
  );
};

export default PolicyEmbed;
